import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { DialogService, DialogRef, DialogCloseResult } from '@progress/kendo-angular-dialog';
@Component({
  selector: 'app-modal',
   templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class modalComponent implements OnInit {
   @Output()  onCloseToParent = new EventEmitter<any>();
   @Output()  onOkToParent = new EventEmitter<any>();
   @Input() dialogTitle:string;
   @Input() dialogTextLine1:string;
   @Input() dialogTextLine2:string;
   @Input() primaryButtonText:string;
   @Input() secondaryButtonText:string;
   public secondaryButtonPresent:boolean=true;

  constructor(private dialogService: DialogService) { }

    public onSecondaryButtonClick() {
      this.onCloseToParent.emit();
    }

    public onTertiaryButtonClick() {
        this.onCloseToParent.emit();
    }

    public onPrimaryButtonClick() {
        this.onOkToParent.emit();
    }


  ngOnInit() {
    if(this.secondaryButtonText=="" || this.secondaryButtonText==null){
        this.secondaryButtonPresent=false;

    }
  }

}
